import { installStaleBuildRecovery } from '@frontend/common';
import { SquircleEnhancer } from '@frontend/components/common';
import { TranslationProvider } from '@frontend/lang';
import { SentryErrorBoundary, initSentry } from '@frontend/sentry';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'react-grid-layout/css/styles.css';
import { Provider } from 'react-redux';
import 'react-resizable/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import 'reactflow/dist/style.css';

import App from './app/app';
import { DefaultProviders } from './app/default-providers';
import { store } from './app/redux/store';
import './styles.css';

installStaleBuildRecovery();
initSentry('platform');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <StrictMode>
        <SquircleEnhancer />
        <TranslationProvider>
            <SentryErrorBoundary>
                <Provider store={store}>
                    <DefaultProviders>
                        <App />
                    </DefaultProviders>
                </Provider>
            </SentryErrorBoundary>
        </TranslationProvider>
    </StrictMode>
);
